import * as Yup from "yup";

export const CreateTopicCategory = Yup.object().shape({
	name: Yup.string().required("Category Name is required"),
	description: Yup.string().required("Category Description is required"),
});
